import TextField from '@mui/material/TextField';

const FromTextField = ({
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfSyusekiNo"
    label="集積No"
    size="small"
    inputProps={{ maxLength: 20 }}
    onChange={(event: any) => { onChange(event); }}
  />
);

export default FromTextField;